import React from 'react';
import { CreditCard, Landmark, Edit2, Check, X, Trash2 } from 'lucide-react';

export default function PaymentTypeSection({ 
  paymentTypes, 
  editingPaymentType, 
  setEditingPaymentType,
  handleUpdatePaymentType,
  handleDeletePaymentType 
}) {
  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-bold">Payment Types (Universal)</h2>
          <p className="text-sm text-slate-600">These payment types apply across all processors</p>
        </div>
        {editingPaymentType?.editing ? (
          <div className="flex space-x-2">
            <button onClick={() => setEditingPaymentType(null)} className="px-4 py-2 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold">
              <Check className="w-4 h-4 inline mr-1" />Done
            </button>
          </div>
        ) : (
          <button onClick={() => setEditingPaymentType({ editing: true })} className="px-4 py-2 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-semibold">
            <Edit2 className="w-4 h-4 inline mr-1" />Edit Types
          </button>
        )}
      </div>
      
      <div className="grid grid-cols-2 gap-6">
        {/* Card Payment Types */}
        <div>
          <div className="flex items-center space-x-2 mb-3">
            <CreditCard className="w-5 h-5 text-indigo-600" />
            <h3 className="font-semibold">Card</h3>
          </div>
          <div className="space-y-2">
            {paymentTypes.Card?.map(pt => (
              <div key={pt.id} className="flex justify-between items-center bg-indigo-50 border-indigo-200 border rounded px-3 py-2">
                {editingPaymentType?.id === pt.id ? (
                  <div className="flex space-x-2 flex-1">
                    <input
                      type="text"
                      value={editingPaymentType.name}
                      onChange={(e) => setEditingPaymentType({ ...editingPaymentType, name: e.target.value })}
                      className="input-field text-sm flex-1"
                      placeholder="Name"
                    />
                    <input
                      type="text"
                      value={editingPaymentType.code}
                      onChange={(e) => setEditingPaymentType({ ...editingPaymentType, code: e.target.value.toUpperCase() })}
                      className="input-field text-sm w-20"
                      placeholder="CODE"
                    />
                    <button onClick={() => handleUpdatePaymentType(pt.id)} className="text-green-600 hover:text-green-700">
                      <Check className="w-4 h-4" />
                    </button>
                    <button onClick={() => setEditingPaymentType({ editing: true })} className="text-slate-600 hover:text-slate-700">
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ) : (
                  <>
                    <div>
                      <span className="text-sm font-medium">{pt.name}</span>
                      <span className="text-xs text-slate-500 ml-2">({pt.code})</span>
                    </div>
                    {editingPaymentType?.editing && (
                      <div className="flex space-x-2">
                        {!pt.is_default && (
                          <>
                            <button onClick={() => setEditingPaymentType({ ...pt })} className="text-blue-600 hover:text-blue-700">
                              <Edit2 className="w-4 h-4" />
                            </button>
                            <button onClick={() => handleDeletePaymentType(pt.id, pt.name)} className="text-red-600 hover:text-red-700">
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* ACH Payment Types */}
        <div>
          <div className="flex items-center space-x-2 mb-3">
            <Landmark className="w-5 h-5 text-green-600" />
            <h3 className="font-semibold">ACH</h3>
          </div>
          <div className="space-y-2">
            {paymentTypes.ACH?.map(pt => (
              <div key={pt.id} className="flex justify-between items-center bg-green-50 border-green-200 border rounded px-3 py-2">
                {editingPaymentType?.id === pt.id ? (
                  <div className="flex space-x-2 flex-1">
                    <input
                      type="text"
                      value={editingPaymentType.name}
                      onChange={(e) => setEditingPaymentType({ ...editingPaymentType, name: e.target.value })}
                      className="input-field text-sm flex-1"
                      placeholder="Name"
                    />
                    <input
                      type="text"
                      value={editingPaymentType.code}
                      onChange={(e) => setEditingPaymentType({ ...editingPaymentType, code: e.target.value.toUpperCase() })}
                      className="input-field text-sm w-20"
                      placeholder="CODE"
                    />
                    <button onClick={() => handleUpdatePaymentType(pt.id)} className="text-green-600 hover:text-green-700">
                      <Check className="w-4 h-4" />
                    </button>
                    <button onClick={() => setEditingPaymentType({ editing: true })} className="text-slate-600 hover:text-slate-700">
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ) : (
                  <>
                    <div>
                      <span className="text-sm font-medium">{pt.name}</span>
                      <span className="text-xs text-slate-500 ml-2">({pt.code})</span>
                    </div>
                    {editingPaymentType?.editing && (
                      <div className="flex space-x-2">
                        {!pt.is_default && (
                          <>
                            <button onClick={() => setEditingPaymentType({ ...pt })} className="text-blue-600 hover:text-blue-700">
                              <Edit2 className="w-4 h-4" />
                            </button>
                            <button onClick={() => handleDeletePaymentType(pt.id, pt.name)} className="text-red-600 hover:text-red-700">
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
